export default function RenderQRCode({value, size=200}) {
  return <img src={"https://custom-api.goaffpro.com/qrcode?content=" +
      encodeURIComponent(value) + `&size=${size}`} alt={value}/>

}
